import { render, staticRenderFns } from "./charges_up_push.vue?vue&type=template&id=72ab1b8c&scoped=true"
import script from "./charges_up_push.vue?vue&type=script&lang=js"
export * from "./charges_up_push.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ab1b8c",
  null
  
)

export default component.exports